import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { EducationHostedFormModel, EducationHostedFormSteps } from '../EducationHostedForm.types'
import { useNavigateForm } from '../hooks/useNavigateForm'
import { HasCurrentPageErrorsProps, useHasCurrentPageErrors } from '../hooks/useHasCurrentPageErrors'

import { Step } from '@percent/education-hosted-form/ui/Step/Step'
import { FormField, Flex, TextInput } from '@percent/lemonade'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

export function OrganisationAddress() {
  const { t } = useTranslation()
  const { progress } = useEducationHostedForm()
  const { handleNextStep, handlePreviousStep } = useNavigateForm()

  const { register } = useFormContext<EducationHostedFormModel>()

  const inputFields: HasCurrentPageErrorsProps = [
    {
      fieldKey: 'organisationAddressLine1'
    },
    {
      fieldKey: 'organisationAddressLine2',
      isOptional: true
    },
    {
      fieldKey: 'organisationCity'
    },
    {
      fieldKey: 'organisationState'
    },
    {
      fieldKey: 'organisationPostalCode'
    }
  ]

  const { hasPageErrors, errors, getStatus } = useHasCurrentPageErrors(inputFields)

  const handleNext = () => {
    handleNextStep(EducationHostedFormSteps.AGENT_DETAILS)
  }

  return (
    <Step
      step={EducationHostedFormSteps.ORGANISATION_ADDRESS}
      title={t('organisationAddress.title')}
      description={t('organisationAddress.description')}
      onBack={handlePreviousStep}
      onNext={handleNext}
      nextButtonDisabled={hasPageErrors}
      nextButtonLabel={t('button.next')}
      progress={progress}
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('organisationAddress.addressLine1')}
          status={getStatus(errors.organisationAddressLine1)}
          necessity="required"
          statusMessage={errors.organisationAddressLine1}
        >
          <TextInput
            {...register('organisationAddressLine1')}
            placeholder={t('organisationAddress.addressLine1Placeholder')}
          />
        </FormField>
        <FormField
          label={t('organisationAddress.addressLine2')}
          status={getStatus(errors.organisationAddressLine2)}
          statusMessage={errors.organisationAddressLine2}
        >
          <TextInput
            {...register('organisationAddressLine2')}
            placeholder={t('organisationAddress.addressLine2Placeholder')}
          />
        </FormField>
        <FormField
          label={t('organisationAddress.city')}
          status={getStatus(errors.organisationCity)}
          necessity="required"
          statusMessage={errors.organisationCity}
        >
          <TextInput {...register('organisationCity')} placeholder={t('organisationAddress.cityPlaceholder')} />
        </FormField>
        <FormField
          label={t('organisationAddress.state')}
          status={getStatus(errors.organisationState)}
          necessity="required"
          statusMessage={errors.organisationState}
        >
          <TextInput {...register('organisationState')} placeholder={t('organisationAddress.statePlaceholder')} />
        </FormField>
        <FormField
          label={t('organisationAddress.postalCode')}
          status={getStatus(errors.organisationPostalCode)}
          necessity="required"
          statusMessage={errors.organisationPostalCode}
        >
          <TextInput
            {...register('organisationPostalCode')}
            placeholder={t('organisationAddress.postalCodePlaceholder')}
          />
        </FormField>
      </Flex>
    </Step>
  )
}
